import requestIdleCallback from 'ric-shim'
import { setActivated } from '../components/TabBar/state'

import type { PluginOptions } from './type';

const options: PluginOptions = {
  onVuePluginRegister: async ({ router }) => {
    router?.beforeEach((to, from, next) => {
      // 激活当前tab，路由放到下个时间循环中执行，避免低CPU机型上的资源竞争
      setActivated(to);
      requestIdleCallback(() => {
        next()
      }, { timeout: 100 });
    })
  },
};

export default options;
